import { render, staticRenderFns } from "./BusInfoShopDataRecordsList.vue?vue&type=template&id=0d3d3e3b&scoped=true&"
import script from "./BusInfoShopDataRecordsList.vue?vue&type=script&lang=js&"
export * from "./BusInfoShopDataRecordsList.vue?vue&type=script&lang=js&"
import style0 from "./BusInfoShopDataRecordsList.vue?vue&type=style&index=0&id=0d3d3e3b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d3d3e3b",
  null
  
)

export default component.exports